<!-- 操作中心 -->
<template>
  <div class="operational">
    <el-popover placement="bottom-start" trigger="hover">
      <div class="feet">
        <!--批量添加费用-->
        <el-button
          size="small" type="primary" class="feet-btn"
          @click="onBatchAddingcosts"
        >{{ $t('receivablePayable.AddChargesInBulk') }}
        </el-button>

        <!--导入添加费用-->
        <el-button
          size="small" type="primary" class="feet-btn"
          @click="isImportAdd = true"
        >{{ $t('receivablePayable.ImportAddCharges') }}
        </el-button>

        <!--导入修改费用-->
        <el-button
          size="small" type="primary" class="feet-btn"
          @click="isImportEdit = true"
        >{{ $t('receivablePayable.ImportModifyExpenses') }}
        </el-button>

        <!--快录新增 干支线隐藏-->
        <el-button
          v-if="![5].includes(payableType)"
          size="small" type="primary" class="feet-btn"
          @click="onQR"
        >{{ $t('receivablePayable.QuickRecord') }}
        </el-button>

        <!--批量导入快录 干支线隐藏-->
        <el-button
          v-if="![5].includes(payableType)"
          size="small" type="primary" class="feet-btn"
          @click="onQRImport"
        >{{ $t('receivablePayable.BatchImportClips') }}
        </el-button>
      </div>
      <template #reference>
        <el-button
          v-permit:remove="isAddEditPermission"
          :loading="isAddAndEdit"
          size="small"
        >
          {{ $t('receivablePayable.AddModifyExpenses') }}
        </el-button>
      </template>
    </el-popover>

    <!-- 生成应付 -->
    <el-button
      v-permit:remove="isGenerateBillPermission"
      :loading="isAddAndEdit"
      type="primary"
      size="small"
      @click="onGenerateCope"
    >{{ $t('basicData.GeneratePayables') }}</el-button>

    <!-- 备注（含弹出窗） -->
    <RemarkButCmp
      :ids="selectIdArr"
      :payable-type="payableType"
      :async-sumbit="asyncRemark"
    />

    <!-- 导出 -->
    <div v-permit:remove="isExportPermission">
      <!-- 干支线导出-->
      <el-popover
        v-if="[5].includes(payableType)"
        placement="bottom-start"
        trigger="hover"
      >
        <div class="feet">
          <!-- 查询导出 -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onExport(1)"
          >{{ $t('receivablePayable.ExportPageData') }}
          </el-button>
          <!-- 全量导出 -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onExport(2)"
          >{{ $t('receivablePayable.ExportAllData') }}
          </el-button>
        </div>
        <el-button
          slot="reference"
          size="small"
        >{{ $t('receivablePayable.Export') }}</el-button>
      </el-popover>
      <el-button
        v-if="![5].includes(payableType)"
        size="small" @click="onExport(1)"
      >{{ $t('receivablePayable.Export') }}</el-button>
    </div>

    <div v-permit:remove="isRecalculatePermission">
      <!-- 重新计算（第三方/安俊） -->
      <RecalculateButCmp
        v-if="[1, 2].includes(payableType)"
        :payable-type="payableType" @submit="onRecalculate"
      />

      <!-- AJD重算 -->
      <el-popover
        v-if="[3].includes(payableType)"
        placement="bottom-start"
        trigger="hover"
      >
        <div class="feet">
          <!--          大件-->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRerun(1)"
          >{{ $t('receivablePayable.LargeItemRecalculation') }}
          </el-button>
          <!--          小件-->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRerun(0)"
          >{{ $t('receivablePayable.RecalculateSmallParcels') }}
          </el-button>
        </div>
        <el-button slot="reference" size="small">{{ $t('receivablePayable.RecalculateThePrice') }}</el-button>
      </el-popover>

      <!-- DSP重算/邮局派送/MDD -->
      <el-popover
        v-if="[4,6,7].includes(payableType)"
        placement="bottom-start"
        trigger="hover"
      >
        <el-button slot="reference" size="small">{{ $t('receivablePayable.RecalculateThePrice') }}</el-button>
        <div class="feet">
          <!-- 重新计算价格 10W -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRerunDSP(1)"
          >
            <!--            {{ $t('receivablePayable.RecalculateThePrice') + '(' + $t('receivablePayable.Maximum100000') + ')' }}-->
            {{ $t('receivablePayable.SystemAutoRecalculate') }}
          </el-button>
          <!-- 导入计算价格 -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRerunDSP(2)"
          >{{ $t('receivablePayable.ImportCalculatePrices') }}
          </el-button>
          <!-- 重量批量导入价格 -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRerunDSP(3)"
          >{{ $t('receivablePayable.ImportWeightsCalculatePrices') }}
          </el-button>
        </div>
      </el-popover>

      <!--运输干支线重算费用-->
      <el-popover
        v-if="[5].includes(payableType)"
        placement="bottom-start"
        trigger="hover"
      >
        <el-button slot="reference" size="small">{{ $t('receivablePayable.RecalculateThePrice') }}</el-button>
        <div class="feet">
          <!-- 重新计算价格 10W -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRecalculateThePrice(1)"
          >{{ $t('receivablePayable.RecalculateThePrice') + '(' + $t('receivablePayable.Maximum100000') + ')' }}
          </el-button>
          <!-- 更新重新计算价格 10W -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRecalculateThePrice(2)"
          >{{ $t('receivablePayable.updateDataRecalculatePrice') + '(' + $t('receivablePayable.Maximum100000') + ')' }}
          </el-button>
        </div>
      </el-popover>
    </div>

    <!-- AJD-dialog -->
    <RerunDialog ref="rerunRef" :recalculation-type="recalculationType" @submit="onRecalculate" />

    <!-- DSP/MDD/邮局导入重算 -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="titleList[calculationType]"
      :visible.sync="showImportTemplate"
      width="600px"
    >
      <importDsp
        :key="showImportTemplate"
        :calculation-type="calculationType"
        :business-type="payableType"
        @importPrice="importPrice"
        @close="onClose"
      />
    </el-dialog>

    <!--运输干支线重算-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('receivablePayable.RecalculateThePrice')"
      :visible.sync="showRecalculateThePrice"
      width="600px"
    >
      <recalculate :key="showRecalculateThePrice" @saveReCalculate="saveReCalculate" />
    </el-dialog>

    <!-- 删除（含弹出窗） -->
    <DelButCmp
      :async-sumbit="asyncDel"
      :payable-type="payableType"
    />

    <!-- 自定义列栏目 -->
    <CustomStatusBar :payable-type="payableType" />

    <!-- 干支线-未单程查询-->
    <OneWayDialog v-if="payableType === 5" />

    <!-- 生成应付弹窗 -->
    <AccountsPayable
      ref="generateCopeTimeRef"
      :cb="generateReceivablesSuccess"
      :query-form="queryForm"
      :select-data="selectArr"
      :payable-type="payableType"
      :provider-data="providerData"
      :fee-type-option="feeTypeOption"
    />

    <!-- 显示生成应付结果弹窗 -->
    <AccountsPayableDialog ref="generateCopeListRef" />

    <!-- 批量添加费用 -->
    <AddFee
      ref="notQRAddRef"
      :fee-type-option="feeTypeOption"
      :query-form="queryForm"
      :select-data="selectArr"
      :payable-type="payableType"
      @close="onQRClose"
    />

    <!-- 非快录详情 -->
    <DetailFee
      ref="notQRDetailsRef"
      :query-fee-param="queryFeeParam"
      :fee-type-option="feeTypeOption"
      :query-form="queryForm"
      :select-data="selectArr"
      :payable-type="payableType"
      @close="onQRClose"
    />

    <!-- 导入添加费用 -->
    <el-dialog
      :title="$t('receivablePayable.ImportAddCharges')"
      :visible.sync="isImportAdd"
      width="600px"
    >
      <importAddFees :payable-type="payableType" :fee-type-list="feeTypeOption" @colse="onImportAddClose" />
    </el-dialog>

    <!-- 导入修改费用 -->
    <el-dialog
      :title="$t('receivablePayable.ImportModifyExpenses')"
      :visible.sync="isImportEdit"
      width="600px"
    >
      <importEditFees :payable-type="payableType" :fee-type-list="feeTypeOption" @changeFeeList="changeFeeList" />
    </el-dialog>

    <!-- 添加快录 -->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.SnapshotFee')"
      :visible.sync="addQRRow.isVisible"
      custom-class="drawerClass"
      direction="ltr"
      size="80%"
    >
      <AddQRCmp
        ref="addQRRef"
        :key="addQRRow.key"
        :payable-type="payableType"
        :query-fee-param="queryFeeParam"
        :query-form="queryForm"
        :expense-sub-list="addQRRow.expenseSubList"
        :fee-type-option="feeTypeOption"
        :select-data="selectArr"
        @saveFormSnapshot="onQRClose"
      />
    </el-drawer>

    <!-- 导入快录 -->
    <importQuickRecording
      ref="importQRRef"
      :operator-list="operatorList"
      :outlets-list="outletsList"
      :fee-type-list="feeTypeOption"
      :provider-channel-list="providerChannelList"
      :payable-type="payableType"
    />

    <!-- 更新干支线重算数据-->
    <el-dialog
      :append-to-body="true"
      :close-on-press-escape="false"
      :title="$t('receivablePayable.updateDataRecalculatePrice')"
      :visible.sync="showTransportation"
      width="600px"
    >
      <ImportTransport
        @importTransport="importTransportationPrice"
      />
    </el-dialog>

    <!--    版本选择-->
    <RecalculateDialog
      :visible="visible"
      :quotation-list="quotationList"
      @close="cancel"
      @confirm="RecalculateConfirm"
    />
  </div>
</template>

<script>
import {
  // apiPayableSiteBillGenerateBillNumber,
  apiPayableSiteExpenseBatchDelete,
  apiPayableSiteExpenseExport,
  apiPayableSiteExpenseGetInfo,
  apiPayableSiteExpenseSetRemark,
  apiPayableTransportExpenseBatchDelete,
  apiPayableTransportExpenseExport,
  apiPayableTransportExpenseSetRemark,
  apiPayableSiteExpenseImportReCalculatePrice,
  apiPayableTransportSiteExpenseExportAll,
  apiPayableTransportExpenseGetQuoteByOrderNo
} from '@/api/finance/receivables';
import { initGetData } from '@/views/finance/payableManage/feesPayable/component/utils.js';
import { cloneDeep } from 'lodash-es';
import { goFinanceExportPage } from '@/utils/goExportList.js';
import {
  // beforeSearch,
  searchEmpty,
  QUERY_FEE_PARAM,
  L_TABLE_HEADER,
  AJD_TABLE_HEADER,
  DSP_TABLE_HEADER,
  TF_TABLE_HEADER,
  YJ_TABLE_HEADER
} from '@/views/finance/payableManage/feesPayable/enums.js';
import { setGenerateCheck } from '@/views/finance/payableManage/feesPayable/component/AccountsPayable/utils.js';
import AddFee from '@/views/finance/payableManage/feesPayable/component/AddFeee/index.vue';
import DetailFee from '@/views/finance/payableManage/feesPayable/component/AddFeee/details.vue';
import AddQRCmp from '@/views/finance/payableManage/feesPayable/component/AddQRcmp.vue';
import AccountsPayable from '@/views/finance/payableManage/feesPayable/component/AccountsPayable/index.vue';
import AccountsPayableDialog from '@/views/finance/payableManage/feesPayable/component/AccountsPayable/dialog.vue';
import importAddFees from '@/views/finance/payableManage/feesPayable/ImportCmp/importAddFees.vue';
import importEditFees from '@/views/finance/payableManage/feesPayable/ImportCmp/importEditFees.vue';
import importQuickRecording from '@/views/finance/payableManage/feesPayable/ImportCmp/importQuickRecording.vue';
import RerunDialog from '@/views/finance/payableManage/feesPayable/AJDDispatch/rerunDialog.vue';
import importDsp from '@/views/finance/payableManage/feesPayable/ImportCmp/importDsp.vue';
import RecalculateDialog from '@/views/finance/payableManage/feesPayable/ImportCmp/Dialog/index.vue';

const permissionList = {
  1: {
    edit: 'btn:finance:payableManagement:hut:addEdit',
    export: 'btn:finance:payableManagement:hut:export',
    meet: 'btn:finance:payableManagement:hut:GeneratePayables',
    rerun: 'btn:finance:payableManagement:hut:RecalculateThePrice'
  },
  2: {
    edit: 'btn:finance:payableManagement:threeCollect:addEdit',
    export: 'btn:finance:payableManagement:threeCollect:export',
    meet: 'btn:finance:payableManagement:threeCollect:GeneratePayables',
    rerun: 'btn:finance:payableManagement:threeCollect:RecalculateThePrice'
  },
  3: {
    edit: 'btn:finance:payableManagement:ajd:addEdit',
    export: 'btn:finance:payableManagement:ajd:export',
    meet: 'btn:finance:payableManagement:ajd:GeneratePayables',
    rerun: 'btn:finance:payableManagement:ajd:RecalculateThePrice'
  },
  4: {
    edit: 'btn:finance:payableManagement:dsp:addEdit',
    export: 'btn:finance:payableManagement:dsp:export',
    meet: 'btn:finance:payableManagement:dsp:GeneratePayables',
    rerun: 'btn:finance:payableManagement:dsp:RecalculateThePrice'
  },
  5: {
    edit: 'btn:finance:payableManagement:transportation:addEdit',
    export: 'btn:finance:payableManagement:transportation:export',
    meet: 'btn:finance:payableManagement:transportation:GeneratePayables',
    rerun: 'btn:finance:payableManagement:transportation:RecalculateThePrice'
  },
  6: {
    edit: 'btn:finance:payableManagement:postOfficeDelivery:addEdit',
    export: 'btn:finance:payableManagement:postOfficeDelivery:export',
    meet: 'btn:finance:payableManagement:postOfficeDelivery:GeneratePayables',
    rerun: 'btn:finance:payableManagement:postOfficeDelivery:RecalculateThePrice'
  },
  7: {
    edit: 'btn:finance:payableManagement:dsp:addEdit',
    export: 'btn:finance:payableManagement:dsp:export',
    meet: 'btn:finance:payableManagement:dsp:GeneratePayables',
    rerun: 'btn:finance:payableManagement:dsp:RecalculateThePrice'
  }
};
export default {
  name: 'ActionCenter',

  components: {
    RecalculateDialog,
    AddFee,
    DetailFee,
    AddQRCmp,
    AccountsPayable,
    AccountsPayableDialog,
    importAddFees,
    importEditFees,
    importQuickRecording,
    RerunDialog,
    importDsp,
    DelButCmp: () => import('./DelButCmp.vue'),
    RemarkButCmp: () => import('./RemarkButcmp.vue'),
    RecalculateButCmp: () => import('./RecalculateButcmp.vue'),
    recalculate: () => import('@/views/finance/payableManage/feesPayable/component/AddFeee/recalculate.vue'),
    CustomStatusBar: () => import('@/views/finance/cmp/CustomStatusBar.vue'),
    ImportTransport: () => import('@/views/finance/payableManage/feesPayable/ImportCmp/importTransportation.vue'),
    OneWayDialog: () => import('@/views/finance/payableManage/feesPayable/transportationTrunkFeeder/oneWayDialog.vue')
  },

  props: {
    // 搜索条件
    queryForm: {
      type: Object,
      required: true
    },

    // 多选
    selectData: {
      type: Array,
      required: true
    },

    // 业务类型
    businessType: {
      type: [Number, String],
      default: null, // 2 揽收 3 派送 1 运输干支线
      required: true
    },

    // 账单类型
    payableType: {
      type: [Number, String],
      default: '', // 1 安俊 2 第三方 3 AJD 4 DSP 5 运输（干/支线） 6 邮局投递
      required: true
    }

    // 自定义列选中列
    // checkedColumns: {
    //   type: Array,
    //   default: () => []
    // },

    // customColumnId: {
    //   type: [Number, String],
    //   default: null, // 自定义列id
    // },
  },

  data() {
    return {
      isAddAndEdit: false,
      providerList: [], // 获取应付主体选项
      providerData: [], // 获取运输主体
      outletsList: [], // 获取站点
      operatorList: [], // 获取操作人
      feeTypeOption: [], // 获取费用类型
      providerChannelList: [], // 获取服务商渠道
      queryFeeParam: {}, // 快录详情参数
      isImportAdd: false, // 导入添加费用
      isImportEdit: false, // 导入修改费用
      showImportTemplate: false, // DSP导入重算dialog
      calculationType: null, // 价格重算类型 0 查询结果 1 勾选结果 2 DSP导入 3 DSP导入重量

      // 非快录添加
      addNotQRRow: {
        key: 1,
        addType: 2
      },

      // 非快录详情
      editNotQRRow: {
        key: 1
      },

      // 添加快录
      addQRRow: {
        expenseSubList: [], // 费用详情

        isVisible: false, // 弹窗
        key: 2
      },
      showRecalculateThePrice: false, // 运输干支线价格重算弹窗
      showTransportation: false, // 干支线更新重算
      recalculationType: 0, // AJD重算

      visible: false, // 版本弹窗
      quotationList: {} // 报价数据
    };
  },

  computed: {
    // 获取多选选中的值(只含id)
    selectIdArr() {
      const arr = this.selectData;
      if (arr.length === 0) {
        return [];
      }

      return arr.map(item => {
        return item.id;
      });
    },

    // 获取多选选中的值
    selectArr() {
      return cloneDeep(this.selectData);
    },

    // 重算title
    titleList() {
      return {
        1: this.$t('receivablePayable.RecalculateThePrice'),
        2: this.$t('receivablePayable.ImportCalculatePrices'),
        3: this.$t('receivablePayable.ImportWeightsCalculatePrices')
      };
    },

    // 添加/修改费用权限
    isAddEditPermission() {
      return permissionList[this.payableType].edit;
    },

    // 生成账单权限
    isGenerateBillPermission() {
      return permissionList[this.payableType].meet;
    },

    // 导出权限
    isExportPermission() {
      return permissionList[this.payableType].export;
    },

    // 重算权限
    isRecalculatePermission() {
      return permissionList[this.payableType].rerun;
    }
  },

  // activated() {
  //   this.initData();
  // },

  created() {
    this.initData();
  },

  methods: {
    // 打开运输干支线重新计算价格弹窗
    // 单号、时间必选一个
    onRecalculateThePrice(type) {
      const formData = cloneDeep(this.queryForm);
      const params = formData.params;
      if (type === 1) {
        if (!params.transportNumberList.length && !params.startTime) {
          this.$message.warning(this.$t('receivablePayable.businessTimeOrOrderNumberCannotBeEmpty'));
          return;
        }
        try {
          const count = this.$emit('getTotal');
          if (count > 100000) {
            // 一次仅能重算同一业务类型，数据量小于10w的数据
            this.$message.warning(this.$t('receivablePayable.dataVolume100K'));
            return;
          }
          let msg;
          if (this.selectData.length > 0) {
            msg = this.$t('receivablePayable.PressRecalculateWithChecked');
          } else {
            msg = this.$t('receivablePayable.Recalculate');
          }
          this.$confirm(
            msg, // 点击”确认“按钮，将按照系统最新价格表对当前查询的所有“费用来源”为“系统生成”的费用进行重新核算，是否确认？
            this.$t('basicData.tips'), {
              confirmButtonText: this.$t('basicData.determine'), // '确定',
              cancelButtonText: this.$t('basicData.Cancel'), // '取消',
              type: 'warning'
            }).then(() => {
            const query = {
              pageNumber: 1,
              pageSize: 10,
              orderDirection: 'desc',
              orderProperty: '',
              params: {
                ...params
              }
            };
            const obj = {
              postData: query,
              isBool: true,
              importType: 1
            };

            this.$emit('recalculatePrice', obj);
          }).catch(() => {
            console.info('用户点击取消');
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        // 导入重算弹窗
        this.showTransportation = true;
      }

      // const { transportNumberList, startTime, endTime } = this.queryForm.params;
      // if (transportNumberList && transportNumberList.length > 0 || (startTime && endTime)) {
      //   const query = {
      //     pageNumber: 1,
      //     pageSize: 10,
      //     orderDirection: 'desc',
      //     orderProperty: '',
      //     params: {
      //       ...this.queryForm.params
      //     }
      //   };
      //   const obj = {};
      //   obj.postData = query;
      //   obj.isBool = true;
      //   this.$emit('recalculatePrice', obj);
      // } else {
      //   this.$message.error(this.$t('receivablePayable.businessTimeOrOrderNumberCannotBeEmpty'));
      // }
    },
    saveReCalculate(data) {
      if (data) {
        const query = {
          pageNumber: 1,
          pageSize: 10,
          orderDirection: 'desc',
          orderProperty: '',
          params: {
            loadUserIdList: data.dispatcherList,
            startDate: data.queryDate[0],
            endDate: data.queryDate[1]
          }
        };
        const obj = {};
        obj.postData = query;
        obj.isBool = true;
        this.$emit('recalculatePrice', obj);
      }
      this.showRecalculateThePrice = false;
    },
    // 初始化数据
    initData() {
      this.isAddAndEdit = true;
      initGetData({ payableType: this.payableType }).then(res => {
        this.providerList = res[0];// 应付主体选项
        this.providerData = res[1];// 应付运输主体
        this.outletsList = res[2];// 获取站点
        this.providerChannelList = res[3]; // 服务商渠道
        this.operatorList = res[4];// 操作人
        this.feeTypeOption = res[5];// 费用类型
      }).catch(err => console.error(err)).finally(() => {
        this.isAddAndEdit = false;
      });
    },

    // 刷新列表
    refresh() {
      this.$emit('refresh');
    },

    // 批量添加费用
    onBatchAddingcosts() {
      this.$refs.notQRAddRef.open();
    },

    // 非快录详情
    openNotQRDetail(row) {
      this.queryFeeParam = cloneDeep(row);
      this.$refs.notQRDetailsRef.open();
    },

    // 快录添加
    onQR() {
      let obj = { ...QUERY_FEE_PARAM };
      if (this.selectArr.length > 0) {
        obj = cloneDeep(this.selectArr[0]);
        obj.waybillNumber = obj.waybillNumber.replace('QR', '');
        obj.id = null;
      }
      this.queryFeeParam = obj;
      this.addQRRow.isVisible = true;
      this.addQRRow.key += 1;
    },

    // 查看快录详情
    onQREditFee(row) {
      apiPayableSiteExpenseGetInfo(row).then(res => {
        if (res.code === 200) {
          const obj = cloneDeep(res.data);
          obj.waybillNumber = obj.waybillNumber.replace('QR', '');
          this.queryFeeParam = obj;
          this.addQRRow.expenseSubList = res.data.expenseSubList;
          this.addQRRow.key += 1;
          this.addQRRow.isVisible = true;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 导入添加费用关闭
    onImportAddClose() {
      this.isImportAdd = false;
    },
    // 导入修改费用关闭
    changeFeeList() {
      this.isImportEdit = false;
    },
    // 快录添加关闭
    onQRClose(isBool) {
      this.addQRRow.isVisible = false;

      isBool && this.refresh();
    },

    // 批量添加快录
    onQRImport() {
      this.$refs.importQRRef.open();
    },

    // 生成应付
    onGenerateCope() {
      const { params } = this.queryForm;
      // 判断搜索条件是否为空
      {
        const isBool = searchEmpty(params);

        if (isBool) {
          return;
        }
      }
      // 判断业务类型及操作人
      const [isBool, val] = setGenerateCheck(this.selectArr, params);
      if (!isBool) {
        return;
      }

      // 运输业务判断主体、运输类型
      const { providerId, routeType } = params;
      console.log('params', providerId, routeType);
      if (this.payableType === 5) {
        if (!providerId || !routeType) {
          this.$message.warning(this.$t('basicData.querySubjectAndTransportTypeCannotBeEmpty'));
          return;
        }
      }

      this.$refs.generateCopeTimeRef.open(val);
    },

    // 生成应付 后续处理函数
    generateReceivablesSuccess(data) {
      this.$refs.generateCopeListRef.open(data);
    },

    // 备注提交
    asyncRemark(str) {
      const param = {
        condition: {
          ...this.queryForm.params,
          ids: this.selectIdArr
        },
        remark: str,
        payableType: this.payableType
      };
      const API = this.payableType === 5 ? apiPayableTransportExpenseSetRemark : apiPayableSiteExpenseSetRemark;
      return API(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded')); // '保存成功'
          this.refresh();
        }
      });
    },

    /**
     * 默认导出所有
     * @param {number} type 导出类型 1 默认导出所有 2 干支线全量数据
     */
    onExport(type) {
      console.log(type, typeof type);
      const isBool = searchEmpty(this.queryForm.params);
      if (isBool) return;

      const prop = [];
      const label = [];
      let TABLE_HEADER = L_TABLE_HEADER;
      const HEADER_MAP = {
        payableType: {
          5: TF_TABLE_HEADER,
          6: YJ_TABLE_HEADER,
          3: AJD_TABLE_HEADER,
          4: DSP_TABLE_HEADER
        },
        businessType: {
          2: L_TABLE_HEADER
        }
      };
      if (HEADER_MAP.payableType[this.payableType]) {
        TABLE_HEADER = HEADER_MAP.payableType[this.payableType];
      } else if (HEADER_MAP.businessType[this.businessType]) {
        TABLE_HEADER = HEADER_MAP.businessType[this.businessType];
      }
      // 导出干掉客户信息
      TABLE_HEADER.forEach(item => {
        if (item.prop !== 'customerAlias') {
          prop.push(item.prop);
          label.push(item.label);
        }
      });
      if (type === 2) {
        prop.push(...[
          'lineCode',
          'lineAttribute',
          'operationMode',
          'vehicleModelRequire',
          'deptName',
          'returnToOrigin',
          'totalMileage',
          'forwardNodeName',
          'returnNodeName'
        ]);
        label.push(...[
          '车线编码',
          '车线属性',
          '运营模式',
          '车型要求',
          '所属组织',
          '是否原路返回',
          '总里程',
          '往程节点名称',
          '返程节点名称'
        ]);
      }
      const param = {
        ...this.queryForm.params,
        fieldList: prop,
        headList: label,
        ids: this.selectIdArr
      };
      const fn = this.payableType === 5
        ? type === 2 ? apiPayableTransportSiteExpenseExportAll : apiPayableTransportExpenseExport
        : apiPayableSiteExpenseExport;
      fn(param).then(res => {
        if (res.code === 200) {
          goFinanceExportPage();
        }
      }).catch(err => {
        console.error(err);
      });
    },

    /**
     * 根据费用类型删除费用
     * @param code 费用编号
     */
    asyncDel(code) {
      const param = {
        ...this.queryForm.params,
        feeCode: code, // 费用编号
        ids: this.selectIdArr // 多选订单数据
      };
      const API = this.payableType === 5 ? apiPayableTransportExpenseBatchDelete : apiPayableSiteExpenseBatchDelete;
      return API(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // '操作成功'
          this.refresh();
        }
      });
    },
    // 重算价格（AJD）
    // type：1 大件 0 小件
    onRerun(type) {
      this.recalculationType = type;
      this.$refs.rerunRef.open();
    },
    onRecalculate(data) {
      const obj = {};
      obj.postData = data;
      obj.isBool = true;
      this.$emit('recalculatePrice', obj);
    },
    /**
     * 计算两个日期之间的天数差
     * @param {string} dateStr1 - 开始日期
     * @param {string} dateStr2 - 结束日期
     * @returns {number} 天数差
     */
    getDaysBetweenDates(dateStr1, dateStr2) {
      const date1 = new Date(dateStr1);
      const date2 = new Date(dateStr2);

      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        throw new Error(this.$t('receivablePayable.invalidDateInput'));
      }

      const millisecondsPerDay = 24 * 60 * 60 * 1000;
      const diffInMilliseconds = Math.abs(date2 - date1);
      return Math.ceil(diffInMilliseconds / millisecondsPerDay);
    },

    /**
     * 验证重算条件（时间与单号、数据量限制）
     * @param {Object} formData - 表单数据
     * @returns {boolean} 是否通过验证
     */
    validateRerunConditions(formData) {
      const { numberList, startTime, endTime } = formData;

      // 1. 校验时间与单号二选一
      if (!numberList?.length && !startTime) {
        this.$message.warning(this.$t('receivablePayable.businessTimeOrOrderNumberCannotBeEmpty'));
        return false;
      }

      // 2. 选择业务时间时，校验时间范围和数量限制
      if (startTime) {
        try {
          const days = this.getDaysBetweenDates(startTime, endTime);
          const count = this.$emit('getTotal');

          if (days > 7 || count > 100000) {
            this.$message.warning(this.$t('receivablePayable.OnlyDataSameServiceType'));
            return false;
          }
        } catch (error) {
          return false;
        }
      }
      return true;
    },

    /**
     * 显示重算确认对话框
     * @returns {Promise} 确认对话框的Promise
     */
    showRerunConfirmDialog() {
      const msg = this.selectData.length > 0
        ? this.$t('receivablePayable.PressRecalculateWithChecked')
        : this.$t('receivablePayable.Recalculate');
      return this.$confirm(
        msg,
        this.$t('basicData.tips'),
        {
          confirmButtonText: this.$t('basicData.determine'),
          cancelButtonText: this.$t('basicData.Cancel'),
          type: 'warning'
        }
      );
    },

    /**
     * 重算价格(DSP/MDD/邮局)
     * @param {number} type - 1: 查询重算 2: 导入重算 3: 导入重量重算
     */
    onRerunDSP(type) {
      // 导入类型直接打开弹窗
      if (type !== 1) {
        this.calculationType = type;
        this.showImportTemplate = true;
        return;
      }

      // 查询重算类型需要验证条件
      const formData = cloneDeep(this.queryForm.params);

      if (!this.validateRerunConditions(formData)) {
        return;
      }

      // 显示确认对话框并执行重算
      this.showRerunConfirmDialog()
        .then(() => {
          if (this.payableType !== 6) {
            // 自定义版本重算
            this.queryQuote();
          } else {
            const obj = {
              key: Date.now(),
              isBool: true,
              calculationType: this.selectData.length ? 1 : 0
            };
            this.$emit('recalculatePrice', obj);
          }
        })
        .catch(() => {
          console.info('用户取消重算操作');
        });
    },
    // dsp导入重算
    importPrice(object) {
      this.showImportTemplate = false;
      const {
        data,
        customVersionEnabled,
        customVersionOfferPriceId
      } = object;
      const obj = {
        importData: data,
        key: new Date().getTime(),
        isBool: true,
        calculationType: this.calculationType, // 重算类型
        customVersionEnabled,
        customVersionOfferPriceId
      };
      this.$emit('recalculatePrice', obj);
    },
    onClose() {
      this.showImportTemplate = false;
    },
    // 干支线导入重算
    importTransportationPrice(data) {
      console.log(data, '干支线导入重算');
      this.showTransportation = false;
      apiPayableSiteExpenseImportReCalculatePrice(data).then(res => {
        if (res.code === 200) {
          const obj = {
            postData: {
              pageNumber: 1,
              pageSize: 10
            },
            isBool: true,
            importType: 2
          };

          this.$emit('recalculatePrice', obj);
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 关闭自定义版本弹窗
    cancel() {
      this.visible = false;
    },
    // 版本重算
    RecalculateConfirm(obj) {
      console.log(obj, '查询重算数据');
      this.cancel();
      this.importPrice(obj);
    },
    // 获取自定义版本重算
    // 单号查询报价
    queryQuote() {
      if (this.visible) {
        return;
      }

      this.visible = false;
      this.quotationList = {};

      // 查询参数
      const { params } = this.queryForm;
      params.ids = this.selectData.map(item => item.id);

      apiPayableTransportExpenseGetQuoteByOrderNo(params).then((res) => {
        if (res.code === 200) {
          this.quotationList = res.data;
          // 使用$nextTick确保数据更新后再打开弹窗
          this.$nextTick(() => {
            this.visible = true;
          });
        }
      }).catch((err) => {
        console.log(err);
        this.visible = false;
        this.quotationList = {};
      });
    }
  }
};
</script>

